import { render, staticRenderFns } from "./PageHtml.vue?vue&type=template&id=dda85136"
import script from "./PageHtml.vue?vue&type=script&lang=js"
export * from "./PageHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports